import { useState } from "react";

export const useDueSelection = () => {
    const [selectedDues, setSelectedDues] = useState([]);
    const [selectedDuesTotal, setSelectedDuesTotal] = useState(0);
    const [allSelected, setAllSelected] = useState(true);
    const [hasSelectedDue, setHasSelectedDue] = useState(true);

    const initializeSelectedDues = (data, onTotalCalculated) => {
        const isBookingPayment = data?.data?.data?.isBookingPayment;
        const enableDueSelection = data?.data?.data?.enableDueSelection;

        const dues = data?.data?.data?.dues || [];
        const initialSelectedDues = dues.map((due) => ({
            id: due.id,
            ledgerReferenceId: due.ledgerReferenceId,
            balance: due.balance,
            type: due.type,
            title: due.title,
            rentStartDate: due.rentStartDate,
            rentEndDate: due.rentEndDate,
            selected: enableDueSelection ? true : true,
            dueDate: due.dueDate,
        }));
        setSelectedDues(initialSelectedDues);

        if (enableDueSelection && !isBookingPayment) {
            const total = initialSelectedDues.reduce(
                (sum, due) => sum + parseFloat(due.balance),
                0,
            );
            setSelectedDuesTotal(total);
            if (onTotalCalculated) onTotalCalculated(total);
        } else {
            const totalDues = data?.data?.data?.totalDues || 0;
            setSelectedDuesTotal(totalDues);
            if (onTotalCalculated) onTotalCalculated(totalDues);
        }
        setHasSelectedDue(true);
    };

    const handleDueSelection = (dueId) => {
        const updatedDues = selectedDues.map((due) =>
            due.id === dueId ? { ...due, selected: !due.selected } : due,
        );

        const hasSelected = updatedDues.some((due) => due.selected);
        setSelectedDues(updatedDues);
        setHasSelectedDue(hasSelected);

        const selectedTotal = updatedDues
            .filter((due) => due.selected)
            .reduce((sum, due) => sum + parseFloat(due.balance), 0);

        setSelectedDuesTotal(selectedTotal);
        setAllSelected(updatedDues.every((due) => due.selected));

        return selectedTotal;
    };

    return {
        selectedDues,
        selectedDuesTotal,
        hasSelectedDue,
        allSelected,
        setAllSelected,
        handleDueSelection,
        initializeSelectedDues,
    };
};